import { Component, OnInit, Compiler, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { KeycloakOptions, KeycloakService } from 'keycloak-angular';
import { debounceTime, filter, map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { keyService } from './api-services/keycloak/service/key.service';
import * as $ from 'jquery';
import { BsModalService } from 'ngx-bootstrap/modal';
import { fromEvent } from 'rxjs';
import * as appConstants from '../assets/json/applicationConstants.json';
//import browserUser from '../assets/getUserDetails/getUserDetailsFromBrowser';

//const APP_TITLE = 'Ojaska | ';
const SEPARATOR = ' > ';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  @ViewChild('msg') modalRef: any;
  brandData = appConstants?.commonAppConstants?.brandData;
  APP_TITLE = this.brandData.brandName + "|";
  title = 'ayurwaypages';
  isLoggedIn: boolean;
  roleName: string;
  getRoles: string[];
  disbleRoutes: boolean;
  wellness = environment.ahyushUrl+"/login";
  showBtn$ = fromEvent(document, 'scroll').pipe(
    debounceTime(50),
    map(() => window.scrollY > 500),
    //tap(() => console.log('sas'))
  );
  constructor(
    private activeRouter: ActivatedRoute,
    public router: Router,
    private _compiler: Compiler,
    private titleService: Title,
    private key: keyService,
    private modalService: BsModalService
   
  ) {
    this.ngOnInit();
  }
  async ngOnInit() {//this.getLocation();
    this.isLoggedIn = await this.key.isLoggedIn();
    if (this.isLoggedIn) {
      this.getRoles = this.key.getRoles();
      if (this.getRoles.includes('ROLE_SUPER_ADMIN')) {
        this.roleName = 'Super-Admin';
        this.disbleRoutes = true;
      } else if (this.getRoles.includes('ROLE_GROUP_ADMIN')) {
        this.roleName = 'Group-Admin';
        this.disbleRoutes = false;
      } else if (this.getRoles.includes('ROLE_CUSTOMER_SUPPORT')) {
        this.roleName = 'Clinical-Representative';
        this.disbleRoutes = true;
      } else {
        this.roleName = '';
        this.disbleRoutes = false;
      }
    }
    this._compiler.clearCache();
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activeRouter),
        map((route) => route.firstChild),
        switchMap((route) => route.data),
        map((data) => {
          if (data.title) {
            // If a route has a title set (e.g. data: {title: "Foo"}) then we use it
            return data.title;
          } else {
            // If not, we do a little magic on the url to create an approximation
            return this.router.url.split('/').reduce((acc, frag) => {
              if (acc && frag) {
                acc += SEPARATOR;
              }
              return this.router.url.split('/').reduce((acc, frag) => {
                if (acc && frag) {
                  acc += SEPARATOR;
                }
                return acc + this.ucFirst(frag);
              });
            });
          }
        })
      )
      .subscribe((pathString) =>
        this.titleService.setTitle(`${this.APP_TITLE} ${pathString}`)
      );
  }
  ucFirst(string) {
    if (!string) {
      return string;
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  modalOpen() {
    this.modalService.show(this.modalRef, {
      backdrop: 'static',
      keyboard: false,
    });
  }
  modalClose() {
    this.modalService.hide();
  }
  scrollToTop(){
    //this.scroll.scrollToPosition([0,0]);
    window.scrollTo({top: 0, behavior: 'smooth'});
  }
 

  //position////////////////////////////////////////////////////////
  // getLocation() {
  //   //console.log(browserUser());
  //   console.log("navigator online",navigator.onLine);
  //   console.log("navigator online",navigator.userAgent);
    
  //   let localData = Intl.DateTimeFormat().resolvedOptions();
  //   console.log("localData.timeZone.toLowerCase()",localData.timeZone.toLowerCase()) 
  //   if (!navigator.geolocation) {
  //     console.log('Geolocation API not supported by this browser.');
  //   } else {
  //     console.log('Checking location...');
  //     navigator.geolocation.getCurrentPosition(this.success, this.error);//current location
  //     //navigator.geolocation.watchPosition(this.success);//continuous check location like live location
  //   }
  // }
  // success(position) {
    
  //   let rawPosition=position.coords;
  //   let latitude=rawPosition.latitude;
  //   let longitude=rawPosition.longitude;
  //   let accuracyInMeter=rawPosition.accuracy;
  //   console.log("success() called",latitude,longitude,accuracyInMeter);
    
  // }
  // error() {
  //   console.log('Geolocation error!');
  // }

  // displayLocation(latitude,longitude){
  //       var geocoder;
  //       geocoder = new google.maps.Geocoder();
  //       var latlng = new google.maps.LatLng(latitude, longitude);
  
  //       geocoder.geocode(
  //           {'latLng': latlng}, 
  //           (results, status) =>{
  //               if (status == google.maps.GeocoderStatus.OK) {
  //                   if (results[0]) {
  //                       var add= results[0].formatted_address ;
  //                       var  value=add.split(",");
  
  //                     let  count=value.length;
  //                     let  country=value[count-1];
  //                      let state=value[count-2];
  //                     let  city=value[count-3];
  //                       this.x.innerHTML = "city name is: " + city;
  //                   }
  //                   else  {
  //                       this.x.innerHTML = "address not found";
  //                   }
  //               }
  //               else {
  //                   this.x.innerHTML = "Geocoder failed due to: " + status;
  //               }
  //           }
  //       );
  //   }
  
  
}
